import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmail, notArrayOrEmpty } from './../../utils/helpers';
import t from "../../languages/pl";
import { connect } from 'react-redux';
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";


const DefaultAndIndividualEmails = props => {
    const { defaultEmailsAndPhones, emails, onEmailListChange, onTextChange, setDefaultOnStart} = props;
    const [typedText, setTypedText] = useState("");
    const [defaultEmails, setDefaultEmails] = useState([]);
    const [selectedEmails, setSelectedEmails] = useState([]);

    useEffect(() => {
        if (defaultEmailsAndPhones) {
            setDefaultEmails(defaultEmailsAndPhones.email);
        }
    }, [defaultEmailsAndPhones]);

    useEffect(() => {
        if(emails){
            setSelectedEmails(emails);
        }
    }, [emails]);

    useEffect(() => {
        if(setDefaultOnStart && defaultEmails){
            onEmailListChange(defaultEmails);
        }
    }, [setDefaultOnStart, defaultEmails]);

    useEffect(() => {
        onTextChange(typedText);
    }, [typedText]);

    const handleEmailListChange = (event, emailsArray) => {
        if(!(typeof(event.target.value) === 'string')){
            onEmailListChange(emailsArray);
        }
    };

    const handleChange = (e) => {
        let newValue = e.target.value;
        newValue = newValue.trimStart();
        let dividePattern = /(;|\s)/;
        if (!dividePattern.test(newValue))
            return setTypedText(newValue);
        var newElement = newValue.split(dividePattern)[0];
        if (isEmail(newElement)) {
            if (!selectedEmails.includes(newElement))
                onEmailListChange(data => [...data, newElement]);
            return setTypedText("");
        }
        setTypedText(e.target.value);
    };

    const handleKey = (e) => {
        if (typedText.length === 0 && e.key === "Backspace") {
            if (!notArrayOrEmpty(selectedEmails))
                onEmailListChange(selectedEmails.slice(0, -1));
            setTypedText("");
        }
        else if (e.key === "Enter" && isEmail(typedText)) {
            if (!selectedEmails.includes(typedText))
                onEmailListChange(data => [...data, typedText]);
            setTypedText("");
        }
    };

    return (
        <Fragment>
            <Autocomplete
                freeSolo
                multiple
                onChange={(event, emailArray) => handleEmailListChange(event, emailArray)}
                value={selectedEmails}
                options={defaultEmails}
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                    <TextField {...params}
                        style={{ width: "100%" }}
                        label={t.emailsAddresses}
                        placeholder={t.email}
                        value={typedText}
                        onChange={handleChange}
                        onKeyDown={handleKey}
                    />
                )}
            />
        </Fragment>
    );
};

const mapStateToProps = (state) => ({
    defaultEmailsAndPhones: state.settingsReducer.defaultEmailsAndPhones,
});

DefaultAndIndividualEmails.propTypes = {
    defaultEmailsAndPhones: PropTypes.object,
    emails: PropTypes.array,
    onEmailListChange: PropTypes.func,
    onTextChange: PropTypes.func,
    setDefaultOnStart: PropTypes.bool,
};
export default connect(mapStateToProps)(DefaultAndIndividualEmails);
